import { getWeekOfYear } from '../../../reducer/weekOfYearSlice';
import { getAreaLevel } from '../../../reducer/areaLevelSlice';
import { getDisease } from '../../../reducer/diseaseSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import dotenv from 'react-dotenv';
import { getAmphurDataMap, getAmphurData, getProvinceDataMap, getProvinceData, getTambonData } from '../../../reducer/areaDataSlice';
import { getIAAM } from '../../../reducer/iaamSlice';
import { setMorbidityChecked, setMorbidityRate, setPopulationRate, setThemeSelectedValue } from '../../../reducer/morbidityRateSlice';
// import { LoadPatient } from '../../data/PatientData';

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref,) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

function MorbidityRate(props) {
    const { checked } = props;
    const dispatch = useDispatch();
    const iaam = useSelector(getIAAM);
    const provinceData = useSelector(getProvinceData);
    const provinceMap = useSelector(getProvinceDataMap);
    const amphurData = useSelector(getAmphurData);
    const amphurMap = useSelector(getAmphurDataMap);
    const tambonData = useSelector(getTambonData);
    const woy = useSelector(getWeekOfYear);
    const areaLevel = useSelector(getAreaLevel);
    const disease = useSelector(getDisease);
    // const [checked, setChecked] = useState(true);
    const [population, setPopalation] = useState(100000);
    const [people, setPeople] = useState('midyear');
    const [theme, setTheme] = useState("1");

    const [areaPopulation, setAreaPopulation] = useState();
    const [areaPatient, setAreaPatient] = useState();

    const [themeValue, setThemeValue] = useState();
    // const [morbidityData, setMor]
    // const [populationTupe, setPopalationType] = useState('1');

    const setMorbidityDataRenderProvince = () => {
        // var tmp = new Array();
        let tmp = {};
        let provAttrName = "prov_namt";
        let provAttrCode = "prov_code";
        // let provAttrName = "province_name";
        // if (this.language === "us" || this.language === "uk") {
        //     provAttrName = provAttrName + "_eng";
        // }
        for (let index = 0; index < provinceData.length; index++) {
            const element = provinceData[index];
            let patientValue = areaPatient[element[provAttrCode]];
            let populationValue = areaPopulation[element[provAttrCode]];
            if (populationValue) {
                const morbidityRate = patientValue === undefined ? 0 : ((patientValue * population) / populationValue);

                const color = checkConditionMorbidity(morbidityRate);
                let data = {
                    code: element[provAttrCode],
                    name: element[provAttrName],
                    province_code: element[provAttrCode],
                    province_name: element[provAttrName],
                    patient: patientValue !== undefined ? patientValue : 0,
                    location: element.geojson_4326,
                    population: populationValue,
                    value: morbidityRate.toFixed(2),
                    color: color
                }
                tmp[element[provAttrCode]] = data;
                // tmp.push(data);
            }
        }
        dispatch(setMorbidityRate(tmp));
        // console.log(tmp);
        // this.morbidityDataRender = tmp;
    }

    const setMorbidityDataRenderAmphur = () => {
        // var tmp = new Array();
        let tmp = {};
        let provAttrName = "prov_namt";
        let provAttrCode = "prov_code";
        let ampAttrName = "amp_namt";
        let ampAttrCode = "amp_code";
        // let provAttrName = "province_name";
        // let ampAttrName = "amphur_name";
        // if (this.language === "us" || this.language === "uk") {
        //     provAttrName = provAttrName + "_eng";
        //     ampAttrName = ampAttrName + "_eng";
        // }
        for (let index = 0; index < amphurData.length; index++) {
            const element = amphurData[index];
            const prov_code = element[ampAttrCode].substr(0, 2);
            let provData = provinceMap[prov_code];
            let patientValue = areaPatient[element[ampAttrCode]];
            let populationValue = areaPopulation[element[ampAttrCode]];
            if (populationValue) {
                const morbidityRate = patientValue === undefined ? 0 : ((patientValue * population) / populationValue);

                const color = checkConditionMorbidity(morbidityRate);
                let data = {
                    code: element[ampAttrCode],
                    name: element[ampAttrName],
                    amphur_code: element[ampAttrCode],
                    amphur_name: element[ampAttrName],
                    province_code: provData[provAttrCode],
                    province_name: provData[provAttrName],
                    patient: patientValue !== undefined ? patientValue : 0,
                    location: element.geojson_4326,
                    population: populationValue,
                    value: morbidityRate.toFixed(2),
                    color: color
                }
                tmp[element[ampAttrCode]] = data;
                // tmp.push(data);
            }
        }
        dispatch(setMorbidityRate(tmp));
    }

    const setMorbidityDataRenderTambon = () => {
        // var tmp = new Array();
        let tmp = {};
        let provAttrName = "prov_namt";
        let provAttrCode = "prov_code";
        let ampAttrName = "amp_namt";
        let ampAttrCode = "amp_code";
        let tambonAttrName = "tambon_namt";
        let tambonAttrCode = "tambon_code";
        // let provAttrName = "province_name";
        // let ampAttrName = "amphur_name";
        // let tambonAttrName = "tambon_name";
        // if (this.language === "us" || this.language === "uk") {
        //     provAttrName = provAttrName + "_eng";
        //     ampAttrName = ampAttrName + "_eng";
        //     tambonAttrName = tambonAttrName + "_eng";
        // }
        for (let index = 0; index < tambonData.length; index++) {
            const element = tambonData[index];
            const prov_code = element[tambonAttrCode].substr(0, 2);
            const amp_code = element[tambonAttrCode].substr(0, 4);
            let provData = provinceMap[prov_code];
            let ampData = amphurMap[amp_code];
            let patientValue = areaPatient[element[tambonAttrCode]];
            let populationValue = areaPopulation[element[tambonAttrCode]];
        //     var patientData = this.patientData["area_code_" + element.tambon_code];
        //     var populationData = this.populationData["area_code_" + element.tambon_code];
            if (populationValue) {
                const morbidityRate = patientValue === undefined ? 0 : ((patientValue * population) / populationValue);

                const color = checkConditionMorbidity(morbidityRate);
                let data = {
                    code: element[tambonAttrCode],
                    name: element[tambonAttrName],
                    tambon_code: element[tambonAttrCode],
                    tambon_name: element[tambonAttrName],
                    amphur_code: ampData[ampAttrCode],
                    amphur_name: ampData[ampAttrName],
                    province_code: provData[provAttrCode],
                    province_name: provData[provAttrName],
                    patient: patientValue !== undefined ? patientValue : 0,
                    location: element.geojson_4326,
                    population: populationValue,
                    value: morbidityRate.toFixed(2),
                    color: color
                }
        //         var boundary = element.boundary;
                
        //         var population = populationData.population;
        //         data.population = population;
        //         var morbidityRate = (parseFloat(patient) * this.populationValue) / population;
        //         morbidityRate =  parseFloat(morbidityRate.toFixed(2));
        //         data.value = morbidityRate
        //         data.color = this.checkConditionMorbidity(morbidityRate);
        //         data.location = boundary;
                // tmp.push(data);
                tmp[element[tambonAttrCode]] = data;
            }
        }
        dispatch(setMorbidityRate(tmp))
        // this.morbidityDataRender = tmp;
    }

    const checkConditionMorbidity = (value) => {
        let found_condition = false;
        let color;
        if (themeValue) {
            for (let index = 0; index < themeValue.length && !found_condition; index++) {
                const element = themeValue[index];
                let operator_min = element.operator_min;
                let min_value = element.min;
                let operator_max = element.operator_max;
                let max_value = element.max;
                
                min_value = parseInt(min_value);
                max_value = parseInt(max_value);
                if (value === 0) {
                    if (min_value === -1 && max_value === -1) {
                        color = element.color;
                        found_condition = true;
                    }
                } else {
                    if (min_value === -1 && max_value !== -1) {
                        if (checkValueCondition(value, operator_max, max_value)) {
                            color = element.color;
                            found_condition = true;
                        }
                    } else if (min_value !== -1 && max_value === -1) {
                        if (checkValueCondition(value, operator_min, min_value)) {
                            color = element.color;
                            found_condition = true;
                        }
                    } else if (min_value !== -1 && max_value !== -1) {
                        if (checkValueCondition(value, operator_min, min_value) && checkValueCondition(value, operator_max, max_value)) {
                            color = element.color;
                            found_condition = true;
                        }
                    }
                }
                
            }
        }
        return color;
    }

    const checkValueCondition = (value, operator, value_condition) => {
        if (operator === "<") {
            return value < value_condition;
        } else if (operator === "<=") {
            return value <= value_condition;
        } else if (operator === "=") {
            return value === value_condition;
        } else if (operator === ">") {
            return value > value_condition;
        } else if (operator === ">=") {
            return value >= value_condition;
        }
    }

    useEffect(() => {
        const LoadTheme = async () => {
            // const response = await fetch(`${dotenv.WATCH_API_URL}/condition/${theme}`);
            const response = await fetch(`${dotenv.MASTER_API_URL}/visualz/get_condition/${theme}`);
            const result = await response.json();
            dispatch(setThemeSelectedValue(result));
            setThemeValue(result);
            // console.log(result);
        }
        if (checked) {
            LoadTheme();
        }
    }, [theme, checked, dispatch])

    useEffect(() => {
        if (areaPopulation !== undefined && areaPatient !== undefined && themeValue !== undefined) {
            if (areaLevel === 'province') {
                setMorbidityDataRenderProvince();
            } else if (areaLevel === 'amphur') {
                setMorbidityDataRenderAmphur();
            } else if (areaLevel === 'tambon') {
                setMorbidityDataRenderTambon();
            }
        }
    }, [provinceData, amphurData, tambonData, areaLevel, areaPopulation, areaPatient, population, themeValue])

    const callMorbidityRate = useCallback(() => {
        const callPopulation = async () => {

            // let result = await fetch(`${dotenv.WATCH_API_URL}/population/${areaLevel}?population_type=1&year=${woy?.end?.year}`);
            let result = await fetch(`${dotenv.MASTER_API_URL}/pop/get_pop_by_${areaLevel}?population_type=1&year=${woy?.end?.year}`);
            if (result.status === 200) {
                let populationDataMap = {};
                let popData = await result.json();
                for (let index = 0; index < popData.length; index++) {
                    const element = popData[index];
                    populationDataMap[element.area_code] = element.population;
                }
                setAreaPopulation(populationDataMap);
            }
        }
        const callPatient = async () => {
            if (woy.start !== undefined) {
                let access_token = await iaam.getAccessToken();
                
                let options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json', 
                        'Authorization': `bearer ${access_token}`
                    }
                }
                
                let tmpPatient = {};
                let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/d506/total-patient?area_level=${areaLevel}&disease_class=${disease}&start_week=${woy?.start?.week}&start_year=${woy?.start?.year}&end_week=${woy?.end?.week}&end_year=${woy?.end?.year}`, options);
                const resData = await res.json();
                
                for (let index = 0; index < resData.length; index++) {
                    const element = resData[index];
                    tmpPatient[element.code] = element.total_patients;
                }
                setAreaPatient(tmpPatient);

                callPopulation();
            }
        }
        if (areaLevel !== undefined && disease !== undefined && woy?.start !== undefined && iaam !== undefined) {
            if (checked) {
                dispatch(setMorbidityChecked(true));
                callPatient();
            } else {
                // console.log("Test");
                setAreaPatient(undefined);
                setAreaPopulation(undefined);
                dispatch(setMorbidityRate({}));
                dispatch(setMorbidityChecked(false));
            }
        }
    }, [iaam, areaLevel, woy, disease, checked])

    // const handleChange = (event) => {
    //     setChecked(!checked);
    // }

    const handlePopulationChanged = (event) => {
        let pop = event.target.value;
        if (pop === "") {
            pop = "0";
        }
        dispatch(setPopulationRate(pop));
        setPopalation(pop);
    }

    useEffect(() => {
        callMorbidityRate();
    }, [callMorbidityRate])

    // console.log(checked);

    if (checked) {
        return (
            <div style={{
                width: '100%',
                position: 'relative',
                textAlign: 'left'
            }}>
                {/* <MyFormControlLabel checked={checked} onChange={handleChange} value="mobodity_rate" control={<MyRadioButton />} label="อัตราป่วย" /> */}
                <div style={{
                    position: 'relative',
                    marginLeft: '30px',
                    width: 'calc(100% - 30px)',
                    marginBottom: 10
                }}>
                    <div style={{
                        position: 'relative',
                    }}>
                        <TextField
                            label="ต่อประชากร"
                            value={population}
                            onChange={handlePopulationChanged}
                            name="morbidity-rate"
                            id="formatted-numberformat-input"
                            InputProps={{
                                inputComponent: NumericFormatCustom,
                                endAdornment: <InputAdornment position="start">คน</InputAdornment>,
                            }}
                            size="small"
                            sx={{
                                m: '8px 0px 8px 0px',
                                position: 'relative',
                                width: '100%'
                            }}
                        />
                    </div>
                    <div>
                        <FormControl fullWidth size='small' sx={{
                            marginTop: '10px'
                        }}>
                            <InputLabel id="demo-simple-select-label">อ้างอิงประชากร</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={people}
                                label="อ้างอิงประชากร"
                                onChange={(event) => {
                                    setPeople(event.target.value)
                                }}
                            >
                                <MenuItem value={'midyear'}>กลางปี</MenuItem>
                                <MenuItem value={'lastyear'}>ปลายปี</MenuItem>
                                <MenuItem value={'custom'}>กำหนดเอง</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <FormControl fullWidth size='small' sx={{
                            marginTop: '20px'
                        }}>
                            <InputLabel id="theme-morbidity-rate-select-label">เกณฑ์การแสดงผล</InputLabel>
                            <Select
                                labelId="theme-morbidity-rate-select-label"
                                id="theme-morbidity-rate-select"
                                value={theme}
                                label="เกณฑ์การแสดงผล"
                                onChange={(event) => {
                                    setTheme(event.target.value)
                                }}
                            >
                                <MenuItem value={"1"}>[0, 5, 10, 20)</MenuItem>
                                <MenuItem value={'3'}>[0, 5, 10)</MenuItem>
                                <MenuItem value={'2'}>[0, 50, 100, 150)</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
        )
    } else {
        return <></>
    }
}

export default MorbidityRate;